/*
 * 设备判断
 */
import { isInNioCNApp } from '@/util/platform/universal';
export const isIOS = () =>
    window.navigator.userAgent.match(/iPhone|iPad|iPod|Mac OS/i) ? true : false;

export const isWx = () =>
    window.navigator.userAgent.match(/micromessenger/i) ? true : false;

export const isInMp = env => {
    const wx = window.wx;
    if (env) {
        return env === 'minip';
    } else {
        if (isWx() && wx && wx.miniProgram && wx.miniProgram.getEnv) {
            return new Promise((resolve, reject) => {
                wx.miniProgram.getEnv(res => {
                    resolve(res.miniprogram);
                });
            });
        } else {
            return false;
        }
    }
};

export function getChannel() {
    return new Promise(async resolve => {
        const inMp = await isInMp();
        resolve(inMp ? 'mp' : isInNioCNApp() ? 'app' : 'sharingPage');
    });
}

export const getUrlParam = (name, noDecode, str) => {
    const string = str || location.href;
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    const r = string.split('?')[1] ? string.split('?')[1].match(reg) : null;
    if (r != null) {
        return noDecode ? r[2] : decodeURIComponent(r[2]);
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/util/report/nioapp-event-report/utils.js